module.exports = __webpack_public_path__ + "assets/img/more-btn-e791cdfa.png";